import Page from "../Common/Page";
import React from "react";
import {
  Table,
  Form,
  Button,
  Row,
  Col,
  Select,
  InputNumber,
  Space,
  message,
  Modal,
} from "antd";
import { JudgmentUnitSelecter } from "../Components/JudgmentUnitSelecter";
import { http } from "../Common/http";
import { AuthContext } from "../Auth/Auth";
import { AbsenceTag } from "../Common/Icons";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { AuthorityButton } from "../Components/AuthorityButton";
import { CommonMasterSelect } from "../Components/CommonMasterSelect";
import { Messages } from "../Common/ValidateMessages";

const { confirm } = Modal;

interface SelectOptionData {
  id: string;
  name: string;
  passFailureFlag: string;
  defaultFlag: string;
}
const { Option } = Select;

interface SearchResultBean {
  searchResult: any[];
  examinationSubjectNames: any[];
  errorType: number;
  errorSeq: number;
  passFailureStatus: number;
}

interface StateType {
  defaultFy: string;
  columns: any[];
  datas: any[];
  passFailureOptions: SelectOptionData[];
  seqOptions: SelectOptionData[];
  // loginError: string;
  // loginTypeMsg: string;
  // loginErrorMsg: string;
  PassFailureIdPass: string;
  PassFailureIdfailure: string;
  PassFailureIdabsence: string;
  passFailureStatus: number;
  seq: string;
}

interface PassFailureData {
  applicantId: string;
  passFailure: string;
}

export class PassFailureJustmentPage extends React.Component<any, StateType> {
  static contextType = AuthContext;

  private _page: React.RefObject<Page>;
  private _formRef: React.RefObject<any>;

  constructor(props: any, context) {
    super(props, context);
    this._page = React.createRef<Page>();
    this._formRef = React.createRef();
    this.state = {
      defaultFy: context.user.currentYear.toString(),
      columns: [],
      datas: [],
      passFailureOptions: [],
      seqOptions: [],
      // loginError: "none",
      // loginTypeMsg: "",
      // loginErrorMsg: "",
      PassFailureIdPass: "",
      PassFailureIdfailure: "",
      PassFailureIdabsence: "",
      passFailureStatus: 0,
      seq: "",
    };
  }
  async componentDidMount() {
    const options = await this.getPassFailureOptions();
    this.setState({
      passFailureOptions: options,
    });
  }
  getPassFailureOptions = async (): Promise<SelectOptionData[]> => {
    let path = `/Master/passfailures?fy=${this.state.defaultFy}`;
    const result = await http<SelectOptionData[]>({
      path: path,
      accessToken: this.context.accessToken,
    });
    const options: any[] = [];
    if (result.ok && result.body) {
      result.body.forEach((element) => {
        options.push(
          <Option key={element.id} value={element.id}>
            {element.name}
          </Option>
        );
        if (element.passFailureFlag === "0" && element.defaultFlag === "1") {
          this.setState({
            PassFailureIdfailure: element.id,
          });
        }
        if (element.passFailureFlag === "1" && element.defaultFlag === "1") {
          this.setState({
            PassFailureIdPass: element.id,
          });
        }
        if (element.passFailureFlag === "2" && element.defaultFlag === "1") {
          this.setState({
            PassFailureIdabsence: element.id,
          });
        }
      });
      return options;
    } else {
      return [];
    }
  };
  // onChange = (pagination: any, filters: any, sorter: any, extra: any) => {
  //   console.log("params", pagination, filters, sorter, extra);
  // };
  defaultColumns = [
    {
      title: <div className="table-title">No</div>,
      dataIndex: "no",
      key: "no",
      width: "5%",
    },
    {
      title: <div className="table-title">順位</div>,
      key: "ranking",
      width: "5%",
      render: (value: any, item: any, index: number) => {
        if (item.finished === 1) {
          return "-";
        } else {
          return item.ranking;
        }
      },
    },
    {
      title: <div className="table-title">受験番号</div>,
      dataIndex: "examNo",
      key: "examNo",
      sorter: {
        compare: (a: any, b: any) => {
          return a.examNo.localeCompare(b.examNo);
        },
        multiple: 1,
      },
    },
    {
      title: <div className="table-title">合計</div>,
      dataIndex: "totalScore",
      className: "score-column",
      key: "sum",
      sorter: {
        compare: (a: any, b: any) => {
          if (a.absenceFlag !== b.absenceFlag)
            return b.absenceFlag.localeCompare(a.absenceFlag);
          else return a.totalScore - b.totalScore;
        },
        multiple: 1,
      },
    },
    {
      title: "",
      key: "action",
      render: (value: any, item: any, index: number) => {
        // console.log(
        //   `${item.finishedSeq} ${this.state.seq} ${
        //     item.finishedSeq !== this.state.seq
        //   }`
        // );
        if (item.finished === 1) {
          return (
            <Select
              style={{ width: 100 }}
              defaultValue={item.finishedPassFailureId}
              disabled={true}
            >
              {this.state.passFailureOptions}
            </Select>
          );
        } else {
          if (this.state.passFailureStatus === 2) {
            return (
              <Select
                style={{ width: 100 }}
                defaultValue={item.passFailureId}
                disabled={true}
              >
                {this.state.passFailureOptions}
              </Select>
            );
          } else {
            return (
              <Form.Item
                name={`action_${item.applicantId}`}
                initialValue={item.passFailureId}
              >
                <Select
                  allowClear={true}
                  style={{ width: 100 }}
                  onChange={() => {
                    this.setState({ passFailureStatus: 0 });
                  }}
                >
                  {this.state.passFailureOptions}
                </Select>
              </Form.Item>
            );
          }
        }
      },
    },
  ];

  showSearchResult = (result: any) => {
    const scoreCloumns: any[] = [];
    if (result.ok && result.body) {
      if (result.body.errorType === 1) {
        message.error(`${result.body.errorSeq}${Messages["ERR-079"]}`);
      } else if (result.body.errorType === 2) {
        message.error(Messages["ERR-080"]);
      } else if (result.body.errorType === 3) {
        message.error(Messages["ERR-081"]);
      } else if (result.body.errorType === 4) {
        message.error(Messages["ERR-082"]);
      } else if (result.body.errorType === 5) {
        message.error(Messages["ERR-083"]);
      } else {
        if (result.body.examinationSubjectNames) {
          result.body.examinationSubjectNames.forEach(
            (scoreColumn, esIndex) => {
              scoreCloumns.push({
                title: (
                  <div className="table-title">
                    {scoreColumn.examinationNumType > 1
                      ? `${scoreColumn.seq}次:`
                      : ""}
                    {scoreColumn.subjectName}
                  </div>
                ),
                key: `Score${esIndex}`,
                sorter: {
                  compare: (a: any, b: any) => {
                    let scoreA = 0;
                    let scoreB = 0;
                    let absA = "0";
                    let absB = "0";
                    if (a.scoreList && a.scoreList.length > 0) {
                      const filterArrayA = a.scoreList.filter(
                        (element, filterIndex, array) =>
                          element.examinationSubjectId ===
                          scoreColumn.examinationSubjectId
                      );
                      if (filterArrayA.length > 0) {
                        scoreA = filterArrayA[0].totalScore;
                        absA = filterArrayA[0].absenceFlag;
                      }
                    }
                    if (b.scoreList && b.scoreList.length > 0) {
                      const filterArrayB = b.scoreList.filter(
                        (element, filterIndex, array) =>
                          element.examinationSubjectId ===
                          scoreColumn.examinationSubjectId
                      );
                      if (filterArrayB.length > 0) {
                        scoreB = filterArrayB[0].totalScore;
                        absB = filterArrayB[0].absenceFlag;
                      }
                    }
                    if (absA !== absB) return absB.localeCompare(absA);
                    else return scoreA - scoreB;
                  },
                  multiple: 1,
                },
                render: (value: any, item: any, index: number) => {
                  if (item.scoreList && item.scoreList.length > 0) {
                    const filterArray = item.scoreList.filter(
                      (element, filterIndex, array) =>
                        element.examinationSubjectId ===
                        scoreColumn.examinationSubjectId
                    );
                    if (filterArray.length > 0) {
                      let totalScore = filterArray[0].totalScore;
                      if (filterArray[0].absenceFlag === "1") {
                        totalScore = AbsenceTag;
                      }
                      return totalScore;
                    }
                  }
                  return "";
                },
              });
            }
          );
        }

        let updatedCloumns;
        if (
          this.context.user.userTypeCode !== "UNIV_HEAD" &&
          this.context.user.userTypeCode !== "UNIV_GRADER"
        ) {
          updatedCloumns = [
            ...this.defaultColumns.slice(0, 3),
            ...scoreCloumns,
            ...this.defaultColumns.slice(3),
          ];
        } else {
          updatedCloumns = [
            ...this.defaultColumns.slice(0, 2),
            ...scoreCloumns,
            ...this.defaultColumns.slice(3),
          ];
        }
        this.setState({
          datas: result.body.searchResult,
          columns: updatedCloumns,
          passFailureStatus: result.body.passFailureStatus,
        });
        // console.log(result.body.passFailureStatus);
        this.state.datas.forEach((element) => {
          if (element.finished === 1) {
          } else {
            if (this.state.passFailureStatus === 2) {
            } else {
              const keyname = "action_" + element.applicantId;
              this._formRef.current.setFieldsValue({
                [keyname]: element.passFailureId,
              });
            }
          }
        });
        this._formRef.current.setFieldsValue({
          total: "",
        });
      }
    } else {
      message.error(Messages["ERR-084"]);
    }
  };

  // 合否設定
  doTotal = async (formValues: any) => {
    try {
      this._page.current?.setState({ isPageLoading: true });
      this.state.datas.forEach((element) => {
        const keyname = "action_" + element.applicantId;
        if (element.absenceFlag === "0") {
          if (formValues.total <= element.totalScore) {
            this._formRef.current.setFieldsValue({
              [keyname]: this.state.PassFailureIdPass,
            });
          } else {
            this._formRef.current.setFieldsValue({
              [keyname]: this.state.PassFailureIdfailure,
            });
          }
        }
      });
      this.setState({ passFailureStatus: 0 });
      this._page.current?.setState({ isPageLoading: false });
    } catch (error) {
      console.log(error);
      this._page.current?.setState({ isPageLoading: false });
    }
  };

  // 検索処理
  doSearch = async (formValues: any) => {
    try {
      this._page.current?.setState({ isPageLoading: true });
      const searchData = {
        Fy: this.state.defaultFy,
        JudgementUnitId: formValues.judgmentUnit
          ? formValues.judgmentUnit
          : null,
        Seq: formValues.seq ? formValues.seq : null,
      };
      const result = await http<
        SearchResultBean,
        { Fy: string; JudgementUnitId: string; Seq: string }
      >({
        path: "/AdmissionDecision/search",
        method: "post",
        body: searchData,
        accessToken: this.context.accessToken,
      });
      this.setState({
        datas: [],
        columns: [],
        passFailureStatus: 0,
      });
      this.showSearchResult(result);
      this._page.current?.setState({ isPageLoading: false });
    } catch (error) {
      console.log(error);
      message.error(Messages["ERR-084"]);
      this.setState({
        datas: [],
        columns: [],
        passFailureStatus: 0,
      });
      this._page.current?.setState({ isPageLoading: false });
    }
  };

  doSave = async (formValues: any) => {
    let haveEmpty = false;
    this.state.datas.forEach((element) => {
      if (!element.finishedPassFailureId) {
        const keyname = "action_" + element.applicantId;
        let pfResult = this._formRef.current.getFieldValue(keyname);
        if (pfResult === undefined || pfResult == null || pfResult === "") {
          haveEmpty = true;
        }
      }
    });
    if (haveEmpty) {
      confirm({
        title: Messages["CON-026"],
        icon: <ExclamationCircleOutlined />,
        onOk: () => {
          this.save(formValues, true);
        },
        onCancel: () => {
          this.save(formValues, false);
        },
        okText: "はい",
        cancelText: "いいえ",
      });
    } else {
      confirm({
        title: Messages["CON-028"],
        icon: <ExclamationCircleOutlined />,
        onOk: () => {
          this.save(formValues, false);
        },
        onCancel: () => {},
        okText: "はい",
        cancelText: "いいえ",
      });
    }
  };
  save = async (formValues: any, needAutoSet: boolean) => {
    try {
      let passFailureList: PassFailureData[] = [];
      this._page.current?.setState({ isPageLoading: true });
      this.state.datas.forEach((element) => {
        if (!element.finishedPassFailureId) {
          const keyname = "action_" + element.applicantId;
          let pfResult = this._formRef.current.getFieldValue(keyname);
          if (pfResult === undefined || pfResult == null || pfResult === "") {
            if (needAutoSet) {
              pfResult = this.state.PassFailureIdfailure;
              const item: PassFailureData = {
                applicantId: element.applicantId,
                passFailure: pfResult,
              };
              passFailureList.push(item);
              this._formRef.current.setFieldsValue({
                [keyname]: pfResult,
              });
            }
          } else {
            const item: PassFailureData = {
              applicantId: element.applicantId,
              passFailure: pfResult,
            };
            passFailureList.push(item);
          }
        }
      });
      const _PostSearchData = {
        Fy: this.state.defaultFy,
        JudgementUnitId: formValues.judgmentUnit
          ? formValues.judgmentUnit
          : null,
        Seq: formValues.seq ? formValues.seq : null,
        PassFailureData: passFailureList,
      };
      const result = await http<
        SearchResultBean,
        {
          Fy: string;
          JudgementUnitId: string;
          Seq: string;
          PassFailureData: PassFailureData[];
        }
      >({
        path: "/AdmissionDecision/save",
        method: "post",
        body: _PostSearchData,
        accessToken: this.context.accessToken,
      });
      message.info(Messages["MSG-010"]);
      this.showSearchResult(result);
      this._page.current?.setState({ isPageLoading: false });
    } catch (error) {
      console.log(error);
      this._page.current?.setState({ isPageLoading: false });
    }
  };
  doConfirm = async (formValues: any) => {
    try {
      this._page.current?.setState({ isPageLoading: true });
      const _PostSearchData = {
        Fy: this.state.defaultFy,
        JudgementUnitId: formValues.judgmentUnit
          ? formValues.judgmentUnit
          : null,
        Seq: formValues.seq ? formValues.seq : null,
      };
      const result = await http<
        SearchResultBean,
        {
          Fy: string;
          JudgementUnitId: string;
          Seq: string;
        }
      >({
        path: "/AdmissionDecision/confirm",
        method: "post",
        body: _PostSearchData,
        accessToken: this.context.accessToken,
      });
      message.info(Messages["MSG-011"]);
      this.showSearchResult(result);
      this._page.current?.setState({ isPageLoading: false });
    } catch (error) {
      console.log(error);
      this._page.current?.setState({ isPageLoading: false });
    }
  };

  handleSubmit = async (e) => {
    // this.setState({ proc: e.currentTarget.value });
    let formValues: any;
    // 検索
    if (e.currentTarget.value === "search") {
      try {
        formValues = await this._formRef.current.validateFields([
          "fy",
          "judgmentUnit",
          "seq",
        ]);
        await this.doSearch(formValues);
      } catch (errorInfo) {
        console.log("Failed:", errorInfo);
        return;
      }
    }
    // 保存
    else if (e.currentTarget.value === "save") {
      try {
        formValues = await this._formRef.current.validateFields([
          "judgmentUnit",
          "seq",
        ]);
        await this.doSave(formValues);
      } catch (errorInfo) {
        console.log("Failed:", errorInfo);
        return;
      }
    }
    // 確定
    else if (e.currentTarget.value === "confirm") {
      try {
        confirm({
          title: Messages["CON-029"],
          icon: <ExclamationCircleOutlined />,
          onOk: async () => {
            formValues = await this._formRef.current.validateFields([
              "judgmentUnit",
              "seq",
            ]);
            await this.doConfirm(formValues);
          },
          onCancel: () => {},
        });
      } catch (errorInfo) {
        console.log("Failed:", errorInfo);
        return;
      }
    }
    // 合否設定
    else if (e.currentTarget.value === "total") {
      try {
        formValues = await this._formRef.current.validateFields(["total"]);
        await this.doTotal(formValues);
      } catch (errorInfo) {
        console.log("Failed:", errorInfo);
        message.error(Messages["ERR-085"]);
        return;
      }
    }
  };

  onFyChange = (newValue) => {
    this.setState(
      {
        datas: [],
        passFailureOptions: [],
        seqOptions: [],
        defaultFy: newValue.value,
        seq: "",
      },
      async () => {
        const options = await this.getPassFailureOptions();
        this.setState({
          passFailureOptions: options,
        });
      }
    );
    // this._formRef.current.setFieldsValue({ seq: undefined });
  };

  onSeqChanged = (newValue) => {
    this.setState({
      seq: newValue,
    });
  };

  getSeqOptions = async (jid: string): Promise<SelectOptionData[]> => {
    let path = `/Master/examseqs`;
    path = path + `?jid=${jid}`;
    const result = await http<SelectOptionData[]>({
      path: path,
      accessToken: this.context.accessToken,
    });
    if (result.ok && result.body) {
      return result.body;
    } else {
      return [];
    }
  };

  onJudgmentUnitSelected = async (record: any) => {
    // console.log("Success:", record);
    if (
      record &&
      record.fyJudgementUnitId &&
      record.fyJudgementUnitId.length > 0
    ) {
      const seqOptions = await this.getSeqOptions(record.fyJudgementUnitId);

      this.setState(
        {
          seqOptions: seqOptions,
          seq: seqOptions.length > 0 ? seqOptions[0].id : "",
          datas: [],
        },
        async () => {
          try {
            this._formRef.current.setFieldsValue({
              seq: seqOptions.length > 0 ? seqOptions[0].id : "",
            });
            var formValues = await this._formRef.current.validateFields([
              "fy",
              "judgmentUnit",
              "seq",
            ]);
            await this.doSearch(formValues);
          } catch (errorInfo) {
            console.log("Failed:", errorInfo);
            return;
          }
        }
      );
    } else {
      this.setState({
        seqOptions: [],
        seq: "",
        datas: [],
      });
    }
    // this._formRef.current.setFieldsValue({ seq: undefined });
  };

  render(): React.ReactNode {
    return (
      <Page ref={this._page} title="合否判定">
        <div className="data_content">
          {/* <Row style={{ display: this.state.loginError }}>
            <Col span={12}>
              <Alert
                type="error"
                description={this.state.loginErrorMsg}
                message={this.state.loginTypeMsg}
                closable
              />
            </Col>
          </Row> */}
          <Form
            colon={false}
            labelCol={{ span: 8 }}
            layout="horizontal"
            labelAlign="left"
            name="searchForm"
            ref={this._formRef}
            initialValues={{
              fy: { value: this.state.defaultFy },
            }}
            fields={[{ name: "seq", value: this.state.seq }]}
          >
            <div className="search_form" style={{ width: "100%" }}>
              <Row>
                <Col span={6}>
                  <Form.Item
                    label="入試年度"
                    name="fy"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <CommonMasterSelect
                      allowClear={false}
                      masterType={31}
                      onChange={this.onFyChange}
                    />
                  </Form.Item>
                </Col>
                <Col span={18}>
                  <Form.Item
                    labelCol={{ span: 2 }}
                    label="判定単位"
                    name="judgmentUnit"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <JudgmentUnitSelecter
                      width={500}
                      defaultFy={this.state.defaultFy}
                      onDataSelect={this.onJudgmentUnitSelected}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={6}>
                  <Form.Item
                    label="N次"
                    name="seq"
                    rules={[{ required: true }]}
                  >
                    <Select
                      style={{ width: 160 }}
                      allowClear={false}
                      onChange={this.onSeqChanged}
                    >
                      {this.state.seqOptions.length > 0 &&
                        this.state.seqOptions.map((data: any) => (
                          <Option key={data.id} value={data.id}>
                            {data.name}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={12}></Col>
                <Col span={6}>
                  <Form.Item>
                    <Button
                      type="primary"
                      value="search"
                      onClick={(e) => this.handleSubmit(e)}
                    >
                      表示
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </div>
            <Row>
              <Col span={16}>
                <ul className="resultCount">
                  <li className="grey">
                    対象<span>{this.state.datas.length}</span>
                  </li>
                </ul>
              </Col>
              <Col span={3}>
                <Form.Item>
                  <AuthorityButton
                    disabled={
                      this.state.datas.length === 0 ||
                      this.state.passFailureStatus === 2
                    }
                    type="primary"
                    style={{ float: "right" }}
                    value="save"
                    onClick={(e) => this.handleSubmit(e)}
                  >
                    保存
                  </AuthorityButton>
                </Form.Item>
              </Col>
              <Col span={1}></Col>
              <Col span={3}>
                <Form.Item>
                  <AuthorityButton
                    disabled={
                      this.state.datas.length === 0 ||
                      this.state.passFailureStatus !== 1
                    }
                    type="primary"
                    style={{ float: "left" }}
                    value="confirm"
                    onClick={(e) => this.handleSubmit(e)}
                  >
                    確定
                  </AuthorityButton>
                </Form.Item>
              </Col>
              <Col span={1}></Col>
            </Row>

            <Row>
              <Col span={24}>
                <Table
                  bordered
                  rowKey={(record: any) => record.examNo}
                  showSorterTooltip={false}
                  pagination={false}
                  columns={this.state.columns}
                  dataSource={this.state.datas}
                  sortDirections={["ascend", "descend"]}
                  scroll={{ y: "calc(100vh - 350px)" }}
                  rowClassName={(record, index) => {
                    if (record.finished === 1) {
                      return "background_color_grey";
                    } else {
                      return "";
                    }
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col span={24}>
                <Space>
                  <span>合格とする合計点</span>
                  <Form.Item
                    name="total"
                    rules={[
                      {
                        required: true,
                        message: Messages["ERR-086"],
                      },
                    ]}
                    noStyle
                  >
                    <InputNumber min={1} />
                  </Form.Item>
                  <span>点以上</span>
                  <Form.Item>
                    <Button
                      disabled={
                        this.state.datas.length === 0 ||
                        this.state.passFailureStatus === 2
                      }
                      type="primary"
                      style={{ float: "right" }}
                      value="total"
                      onClick={(e) => this.handleSubmit(e)}
                    >
                      反映
                    </Button>
                  </Form.Item>
                </Space>
              </Col>
            </Row>
          </Form>
        </div>
      </Page>
    );
  }
}
